webpackJsonp(["conditioner22","conditioner46","conditioner34"],{

/***/ "./node_modules/flexsearch/dist/flexsearch.light.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 FlexSearch v0.6.30
 Copyright 2019 Nextapps GmbH
 Author: Thomas Wilkerling
 Released under the Apache 2.0 Licence
 https://github.com/nextapps-de/flexsearch
*/


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

(function (n, C, D) {
  var t = void 0;(t = D.define) && t.amd ? t([], function () {
    return C;
  }) : (t = D.modules) ? t[n.toLowerCase()] = C : "object" === ( false ? "undefined" : _typeof(exports)) ? module.exports = C : D[n] = C;
})("FlexSearch", function () {
  function n(a, b) {
    var c = b ? b.id : a && a.id;this.id = c || 0 === c ? c : T++;this.init(a, b);D(this, "index", function () {
      return Object.keys(this.c);
    });D(this, "length", function () {
      return this.index.length;
    });
  }function C(a, b) {
    var c = a.length,
        g = H(b),
        d = [];for (var h = 0, f = 0; h < c; h++) {
      var e = a[h];if (g && b(e) || !g && !b[e]) d[f++] = e;
    }return d;
  }
  function D(a, b, c) {
    Object.defineProperty(a, b, { get: c });
  }function t(a) {
    return new RegExp(a, "g");
  }function K(a, b) {
    for (var c = 0; c < b.length; c += 2) {
      a = a.replace(b[c], b[c + 1]);
    }return a;
  }function I(a, b, c, g, d, h, f, e) {
    if (b[c]) return b[c];d = d ? (e - (f || e / 1.5)) * h + (f || e / 1.5) * d : h;b[c] = d;d >= f && (a = a[e - (d + .5 >> 0)], a = a[c] || (a[c] = []), a[a.length] = g);return d;
  }function M(a, b) {
    if (a) {
      var c = Object.keys(a);for (var g = 0, d = c.length; g < d; g++) {
        var h = c[g],
            f = a[h];if (f) for (var e = 0, k = f.length; e < k; e++) {
          if (f[e] === b) {
            1 === k ? delete a[h] : f.splice(e, 1);break;
          } else "object" === _typeof(f[e]) && M(f[e], b);
        }
      }
    }
  }function U(a, b) {
    a = a.length - b.length;return 0 > a ? 1 : a ? -1 : 0;
  }function N(a, b, c) {
    return a ? { page: a, next: b ? "" + b : null, result: c } : c;
  }function E(a) {
    return "string" === typeof a;
  }function H(a) {
    return "function" === typeof a;
  }function J(a) {
    return "undefined" === typeof a;
  }function P(a) {
    var b = Array(a);for (var c = 0; c < a; c++) {
      b[c] = y();
    }return b;
  }function y() {
    return Object.create(null);
  }var B = { encode: "icase", b: "forward", split: /\W+/, cache: !1, async: !1, m: !1, i: !1, l: !1, a: 9, threshold: 0, depth: 0 },
      O = [];var T = 0;var Q = {},
      R = {};n.create = function (a, b) {
    return new n(a, b);
  };n.registerMatcher = function (a) {
    for (var b in a) {
      a.hasOwnProperty(b) && O.push(t(b), a[b]);
    }return this;
  };n.registerEncoder = function (a, b) {
    F[a] = b.bind(F);return this;
  };n.registerLanguage = function (a, b) {
    Q[a] = b.filter;R[a] = b.stemmer;return this;
  };n.encode = function (a, b) {
    return F[a](b);
  };n.prototype.init = function (a, b) {
    this.j = [];if (b) {
      var c = b.preset;a = b;
    } else a || (a = B), c = a.preset;b = {};this.b = a.tokenize || b.b || this.b || B.b;this.split = J(c = a.split) ? this.split || B.split : E(c) ? t(c) : c;this.i = a.rtl || this.i || B.i;this.threshold = J(c = a.threshold) ? b.threshold || this.threshold || B.threshold : c;this.a = J(c = a.resolution) ? c = b.a || this.a || B.a : c;c <= this.threshold && (this.a = this.threshold + 1);this.depth = "strict" !== this.b || J(c = a.depth) ? b.depth || this.depth || B.depth : c;this.g = (c = J(c = a.encode) ? b.encode || B.encode : c) && F[c] && F[c].bind(F) || (H(c) ? c : this.g || !1);(c = a.matcher) && this.addMatcher(c);if (c = (b = a.lang) || a.filter) {
      E(c) && (c = Q[c]);if (c.constructor === Array) {
        {
          var g = this.g;var h = y();
          for (var f = 0; f < c.length; f++) {
            var e = g ? g(c[f]) : c[f];h[e] = 1;
          }c = h;
        }
      }this.filter = c;
    }if (c = b || a.stemmer) {
      var d;a = E(c) ? R[c] : c;b = this.g;c = [];for (d in a) {
        a.hasOwnProperty(d) && (g = b ? b(d) : d, c.push(t(g + "($|\\W)"), b ? b(a[d]) : a[d]));
      }this.stemmer = d = c;
    }this.h = P(this.a - (this.threshold || 0));this.f = y();this.c = y();return this;
  };n.prototype.encode = function (a) {
    a && (O.length && (a = K(a, O)), this.j.length && (a = K(a, this.j)), this.g && (a = this.g(a)), this.stemmer && (a = K(a, this.stemmer)));return a;
  };n.prototype.addMatcher = function (a) {
    var b = this.j;for (var c in a) {
      a.hasOwnProperty(c) && b.push(t(c), a[c]);
    }return this;
  };n.prototype.add = function (a, b, c, g, d) {
    if (b && E(b) && (a || 0 === a)) {
      var u = "@" + a;if (this.c[u] && !g) return this.update(a, b);if (!d && c) return this.add(a, b, null, g, !0), c(), this;b = this.encode(b);if (!b.length) return this;c = this.b;b = H(c) ? c(b) : b.split(this.split);this.filter && (b = C(b, this.filter));g = y();g._ctx = y();d = b.length;var r = this.threshold,
          v = this.depth,
          w = this.a,
          p = this.h,
          m = this.i;for (var q = 0; q < d; q++) {
        var h = b[q];if (h) {
          var f = h.length,
              e = (m ? q + 1 : d - q) / d,
              k = "";switch (c) {case "reverse":case "both":
              for (var l = f; --l;) {
                k = h[l] + k, I(p, g, k, a, m ? 1 : (f - l) / f, e, r, w - 1);
              }k = "";case "forward":
              for (l = 0; l < f; l++) {
                k += h[l], I(p, g, k, a, m ? (l + 1) / f : 1, e, r, w - 1);
              }break;case "full":
              for (l = 0; l < f; l++) {
                var G = (m ? l + 1 : f - l) / f;for (var x = f; x > l; x--) {
                  k = h.substring(l, x), I(p, g, k, a, G, e, r, w - 1);
                }
              }break;default:
              if (f = I(p, g, h, a, 1, e, r, w - 1), v && 1 < d && f >= r) for (f = g._ctx[h] || (g._ctx[h] = y()), h = this.f[h] || (this.f[h] = P(w - (r || 0))), e = q - v, k = q + v + 1, 0 > e && (e = 0), k > d && (k = d); e < k; e++) {
                e !== q && I(h, f, b[e], a, 0, w - (e < q ? q - e : e - q), r, w - 1);
              }}
        }
      }this.c[u] = 1;
    }return this;
  };n.prototype.update = function (a, b, c) {
    this.c["@" + a] && E(b) && (this.remove(a), this.add(a, b, c, !0));return this;
  };n.prototype.remove = function (a, b, c) {
    var g = "@" + a;if (this.c[g]) {
      if (!c && b) return this.remove(a, null, !0), b(), this;for (b = 0; b < this.a - (this.threshold || 0); b++) {
        M(this.h[b], a);
      }this.depth && M(this.f, a);delete this.c[g];
    }return this;
  };n.prototype.search = function (a, b, c, g) {
    b && H(b) ? (c = b, b = 1E3) : b || 0 === b || (b = 1E3);var d = [],
        h = a;if ("object" === (typeof a === "undefined" ? "undefined" : _typeof(a))) {
      var f = !1;b = a.limit;
      var e = a.threshold;var k = !1;a = a.query;
    }e || (e = this.threshold || 0);if (!g && c) return c(this.search(h, b, null, !0)), this;if (!a || !E(a)) return d;h = this.encode(a);if (!h.length) return d;a = this.b;a = H(a) ? a(h) : h.split(this.split);this.filter && (a = C(a, this.filter));c = a.length;g = !0;h = [];var l = y(),
        u,
        r = 0;1 < c && (this.depth && "strict" === this.b ? u = !0 : a.sort(U));var v;if (!u || (v = this.f)) for (var w = this.a; r < c; r++) {
      var p = a[r];if (p) {
        if (u) {
          if (!m) if (v[p]) {
            var m = p;l[p] = 1;
          } else if (!k) return d;if (k && r === c - 1 && !h.length) u = !1, p = m || p, l[p] = 0;else if (!m) continue;
        }if (!l[p]) {
          var q = [],
              G = !1;var z = 0;if (m = u ? v[m] : this.h) {
            var S = void 0;for (var L = 0; L < w - e; L++) {
              if (S = m[L] && m[L][p]) q[z++] = S, G = !0;
            }
          }if (G) m = p, h[h.length] = 1 < z ? q.concat.apply([], q) : q[0];else {
            g = !1;break;
          }l[p] = 1;
        }
      }
    } else g = !1;if (g) a: {
      var _z = void 0;d = [];!0 === f ? (f = "0", e = "") : e = f && f.split(":");k = h.length;if (1 < k) {
        u = y();m = 0;w = !0;g = 0;var x;for (e && (2 === e.length ? e = !1 : e = x = parseInt(e[0], 10)); m < k; m++) {
          l = m === k - 1;v = h[m];c = v.length;if (!c) {
            d = N(f, _z, v);break a;
          }if (w) if (A) {
            r = A.length;for (a = 0; a < r; a++) {
              u["@" + A[a]] = 1;
            }var A = null;w = !1;
          } else {
            A = v;continue;
          }p = !1;for (a = 0; a < c; a++) {
            if (r = v[a], q = "@" + r, (G = u[q] || 0) && G === m) {
              if (l) {
                if (!x || --x < g) if (d[g++] = r, b && g === b) {
                  d = N(f, g + (e || 0), d);break a;
                }
              } else u[q] = m + 1;p = !0;
            }
          }if (!p) break;
        }A && (d = A);
      } else k && (d = h[0], e && (e = parseInt(e[0], 10)));b && (A = d.length, e && e > A && (e = 0), x = e || 0, _z = x + b, _z < A ? d = d.slice(x, _z) : (_z = 0, x && (d = d.slice(x))));d = N(f, _z, d);
    }return d;
  };n.prototype.clear = function () {
    return this.destroy().init();
  };n.prototype.destroy = function () {
    this.h = this.f = this.c = null;return this;
  };(function () {
    var a = t("\\s+"),
        b = t("[^a-z0-9 ]"),
        c = [t("[-/]"), " ", b, "", a, " "];return function (g) {
      {
        g = K(g.toLowerCase(), c);var h = "",
            f = "";var d = "";for (var e = 0; e < g.length; e++) {
          var k = g[e];if (k !== f) if (e && "h" === k) {
            if (d = "a" === d || "e" === d || "i" === d || "o" === d || "u" === d || "y" === d, ("a" === f || "e" === f || "i" === f || "o" === f || "u" === f || "y" === f) && d || " " === f) h += k;
          } else h += k;d = e === g.length - 1 ? "" : g[e + 1];f = k;
        }g = h;
      }return g;
    };
  })();var F = { icase: function icase(a) {
      return a.toLowerCase();
    } };return n;
}(!1), this);

/***/ }),

/***/ "./node_modules/mark.js/dist/mark.js":
/***/ (function(module, exports, __webpack_require__) {

/*!***************************************************
* mark.js v8.11.1
* https://markjs.io/
* Copyright (c) 2014–2018, Julian Kühnel
* Released under the MIT license https://git.io/vwTVl
*****************************************************/

(function (global, factory) {
	 true ? module.exports = factory() :
	typeof define === 'function' && define.amd ? define(factory) :
	(global.Mark = factory());
}(this, (function () { 'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};











var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();







var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var DOMIterator = function () {
  function DOMIterator(ctx) {
    var iframes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var exclude = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
    var iframesTimeout = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 5000;
    classCallCheck(this, DOMIterator);

    this.ctx = ctx;
    this.iframes = iframes;
    this.exclude = exclude;
    this.iframesTimeout = iframesTimeout;
  }

  createClass(DOMIterator, [{
    key: 'getContexts',
    value: function getContexts() {
      var ctx = void 0,
          filteredCtx = [];
      if (typeof this.ctx === 'undefined' || !this.ctx) {
        ctx = [];
      } else if (NodeList.prototype.isPrototypeOf(this.ctx)) {
        ctx = Array.prototype.slice.call(this.ctx);
      } else if (Array.isArray(this.ctx)) {
        ctx = this.ctx;
      } else if (typeof this.ctx === 'string') {
        ctx = Array.prototype.slice.call(document.querySelectorAll(this.ctx));
      } else {
        ctx = [this.ctx];
      }
      ctx.forEach(function (ctx) {
        var isDescendant = filteredCtx.filter(function (contexts) {
          return contexts.contains(ctx);
        }).length > 0;
        if (filteredCtx.indexOf(ctx) === -1 && !isDescendant) {
          filteredCtx.push(ctx);
        }
      });
      return filteredCtx;
    }
  }, {
    key: 'getIframeContents',
    value: function getIframeContents(ifr, successFn) {
      var errorFn = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};

      var doc = void 0;
      try {
        var ifrWin = ifr.contentWindow;
        doc = ifrWin.document;
        if (!ifrWin || !doc) {
          throw new Error('iframe inaccessible');
        }
      } catch (e) {
        errorFn();
      }
      if (doc) {
        successFn(doc);
      }
    }
  }, {
    key: 'isIframeBlank',
    value: function isIframeBlank(ifr) {
      var bl = 'about:blank',
          src = ifr.getAttribute('src').trim(),
          href = ifr.contentWindow.location.href;
      return href === bl && src !== bl && src;
    }
  }, {
    key: 'observeIframeLoad',
    value: function observeIframeLoad(ifr, successFn, errorFn) {
      var _this = this;

      var called = false,
          tout = null;
      var listener = function listener() {
        if (called) {
          return;
        }
        called = true;
        clearTimeout(tout);
        try {
          if (!_this.isIframeBlank(ifr)) {
            ifr.removeEventListener('load', listener);
            _this.getIframeContents(ifr, successFn, errorFn);
          }
        } catch (e) {
          errorFn();
        }
      };
      ifr.addEventListener('load', listener);
      tout = setTimeout(listener, this.iframesTimeout);
    }
  }, {
    key: 'onIframeReady',
    value: function onIframeReady(ifr, successFn, errorFn) {
      try {
        if (ifr.contentWindow.document.readyState === 'complete') {
          if (this.isIframeBlank(ifr)) {
            this.observeIframeLoad(ifr, successFn, errorFn);
          } else {
            this.getIframeContents(ifr, successFn, errorFn);
          }
        } else {
          this.observeIframeLoad(ifr, successFn, errorFn);
        }
      } catch (e) {
        errorFn();
      }
    }
  }, {
    key: 'waitForIframes',
    value: function waitForIframes(ctx, done) {
      var _this2 = this;

      var eachCalled = 0;
      this.forEachIframe(ctx, function () {
        return true;
      }, function (ifr) {
        eachCalled++;
        _this2.waitForIframes(ifr.querySelector('html'), function () {
          if (! --eachCalled) {
            done();
          }
        });
      }, function (handled) {
        if (!handled) {
          done();
        }
      });
    }
  }, {
    key: 'forEachIframe',
    value: function forEachIframe(ctx, filter, each) {
      var _this3 = this;

      var end = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function () {};

      var ifr = ctx.querySelectorAll('iframe'),
          open = ifr.length,
          handled = 0;
      ifr = Array.prototype.slice.call(ifr);
      var checkEnd = function checkEnd() {
        if (--open <= 0) {
          end(handled);
        }
      };
      if (!open) {
        checkEnd();
      }
      ifr.forEach(function (ifr) {
        if (DOMIterator.matches(ifr, _this3.exclude)) {
          checkEnd();
        } else {
          _this3.onIframeReady(ifr, function (con) {
            if (filter(ifr)) {
              handled++;
              each(con);
            }
            checkEnd();
          }, checkEnd);
        }
      });
    }
  }, {
    key: 'createIterator',
    value: function createIterator(ctx, whatToShow, filter) {
      return document.createNodeIterator(ctx, whatToShow, filter, false);
    }
  }, {
    key: 'createInstanceOnIframe',
    value: function createInstanceOnIframe(contents) {
      return new DOMIterator(contents.querySelector('html'), this.iframes);
    }
  }, {
    key: 'compareNodeIframe',
    value: function compareNodeIframe(node, prevNode, ifr) {
      var compCurr = node.compareDocumentPosition(ifr),
          prev = Node.DOCUMENT_POSITION_PRECEDING;
      if (compCurr & prev) {
        if (prevNode !== null) {
          var compPrev = prevNode.compareDocumentPosition(ifr),
              after = Node.DOCUMENT_POSITION_FOLLOWING;
          if (compPrev & after) {
            return true;
          }
        } else {
          return true;
        }
      }
      return false;
    }
  }, {
    key: 'getIteratorNode',
    value: function getIteratorNode(itr) {
      var prevNode = itr.previousNode();
      var node = void 0;
      if (prevNode === null) {
        node = itr.nextNode();
      } else {
        node = itr.nextNode() && itr.nextNode();
      }
      return {
        prevNode: prevNode,
        node: node
      };
    }
  }, {
    key: 'checkIframeFilter',
    value: function checkIframeFilter(node, prevNode, currIfr, ifr) {
      var key = false,
          handled = false;
      ifr.forEach(function (ifrDict, i) {
        if (ifrDict.val === currIfr) {
          key = i;
          handled = ifrDict.handled;
        }
      });
      if (this.compareNodeIframe(node, prevNode, currIfr)) {
        if (key === false && !handled) {
          ifr.push({
            val: currIfr,
            handled: true
          });
        } else if (key !== false && !handled) {
          ifr[key].handled = true;
        }
        return true;
      }
      if (key === false) {
        ifr.push({
          val: currIfr,
          handled: false
        });
      }
      return false;
    }
  }, {
    key: 'handleOpenIframes',
    value: function handleOpenIframes(ifr, whatToShow, eCb, fCb) {
      var _this4 = this;

      ifr.forEach(function (ifrDict) {
        if (!ifrDict.handled) {
          _this4.getIframeContents(ifrDict.val, function (con) {
            _this4.createInstanceOnIframe(con).forEachNode(whatToShow, eCb, fCb);
          });
        }
      });
    }
  }, {
    key: 'iterateThroughNodes',
    value: function iterateThroughNodes(whatToShow, ctx, eachCb, filterCb, doneCb) {
      var _this5 = this;

      var itr = this.createIterator(ctx, whatToShow, filterCb);
      var ifr = [],
          elements = [],
          node = void 0,
          prevNode = void 0,
          retrieveNodes = function retrieveNodes() {
        var _getIteratorNode = _this5.getIteratorNode(itr);

        prevNode = _getIteratorNode.prevNode;
        node = _getIteratorNode.node;

        return node;
      };
      while (retrieveNodes()) {
        if (this.iframes) {
          this.forEachIframe(ctx, function (currIfr) {
            return _this5.checkIframeFilter(node, prevNode, currIfr, ifr);
          }, function (con) {
            _this5.createInstanceOnIframe(con).forEachNode(whatToShow, function (ifrNode) {
              return elements.push(ifrNode);
            }, filterCb);
          });
        }
        elements.push(node);
      }
      elements.forEach(function (node) {
        eachCb(node);
      });
      if (this.iframes) {
        this.handleOpenIframes(ifr, whatToShow, eachCb, filterCb);
      }
      doneCb();
    }
  }, {
    key: 'forEachNode',
    value: function forEachNode(whatToShow, each, filter) {
      var _this6 = this;

      var done = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function () {};

      var contexts = this.getContexts();
      var open = contexts.length;
      if (!open) {
        done();
      }
      contexts.forEach(function (ctx) {
        var ready = function ready() {
          _this6.iterateThroughNodes(whatToShow, ctx, each, filter, function () {
            if (--open <= 0) {
              done();
            }
          });
        };
        if (_this6.iframes) {
          _this6.waitForIframes(ctx, ready);
        } else {
          ready();
        }
      });
    }
  }], [{
    key: 'matches',
    value: function matches(element, selector) {
      var selectors = typeof selector === 'string' ? [selector] : selector,
          fn = element.matches || element.matchesSelector || element.msMatchesSelector || element.mozMatchesSelector || element.oMatchesSelector || element.webkitMatchesSelector;
      if (fn) {
        var match = false;
        selectors.every(function (sel) {
          if (fn.call(element, sel)) {
            match = true;
            return false;
          }
          return true;
        });
        return match;
      } else {
        return false;
      }
    }
  }]);
  return DOMIterator;
}();

var Mark$1 = function () {
  function Mark(ctx) {
    classCallCheck(this, Mark);

    this.ctx = ctx;
    this.ie = false;
    var ua = window.navigator.userAgent;
    if (ua.indexOf('MSIE') > -1 || ua.indexOf('Trident') > -1) {
      this.ie = true;
    }
  }

  createClass(Mark, [{
    key: 'log',
    value: function log(msg) {
      var level = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'debug';

      var log = this.opt.log;
      if (!this.opt.debug) {
        return;
      }
      if ((typeof log === 'undefined' ? 'undefined' : _typeof(log)) === 'object' && typeof log[level] === 'function') {
        log[level]('mark.js: ' + msg);
      }
    }
  }, {
    key: 'escapeStr',
    value: function escapeStr(str) {
      return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
    }
  }, {
    key: 'createRegExp',
    value: function createRegExp(str) {
      if (this.opt.wildcards !== 'disabled') {
        str = this.setupWildcardsRegExp(str);
      }
      str = this.escapeStr(str);
      if (Object.keys(this.opt.synonyms).length) {
        str = this.createSynonymsRegExp(str);
      }
      if (this.opt.ignoreJoiners || this.opt.ignorePunctuation.length) {
        str = this.setupIgnoreJoinersRegExp(str);
      }
      if (this.opt.diacritics) {
        str = this.createDiacriticsRegExp(str);
      }
      str = this.createMergedBlanksRegExp(str);
      if (this.opt.ignoreJoiners || this.opt.ignorePunctuation.length) {
        str = this.createJoinersRegExp(str);
      }
      if (this.opt.wildcards !== 'disabled') {
        str = this.createWildcardsRegExp(str);
      }
      str = this.createAccuracyRegExp(str);
      return str;
    }
  }, {
    key: 'createSynonymsRegExp',
    value: function createSynonymsRegExp(str) {
      var syn = this.opt.synonyms,
          sens = this.opt.caseSensitive ? '' : 'i',
          joinerPlaceholder = this.opt.ignoreJoiners || this.opt.ignorePunctuation.length ? '\0' : '';
      for (var index in syn) {
        if (syn.hasOwnProperty(index)) {
          var value = syn[index],
              k1 = this.opt.wildcards !== 'disabled' ? this.setupWildcardsRegExp(index) : this.escapeStr(index),
              k2 = this.opt.wildcards !== 'disabled' ? this.setupWildcardsRegExp(value) : this.escapeStr(value);
          if (k1 !== '' && k2 !== '') {
            str = str.replace(new RegExp('(' + this.escapeStr(k1) + '|' + this.escapeStr(k2) + ')', 'gm' + sens), joinerPlaceholder + ('(' + this.processSynomyms(k1) + '|') + (this.processSynomyms(k2) + ')') + joinerPlaceholder);
          }
        }
      }
      return str;
    }
  }, {
    key: 'processSynomyms',
    value: function processSynomyms(str) {
      if (this.opt.ignoreJoiners || this.opt.ignorePunctuation.length) {
        str = this.setupIgnoreJoinersRegExp(str);
      }
      return str;
    }
  }, {
    key: 'setupWildcardsRegExp',
    value: function setupWildcardsRegExp(str) {
      str = str.replace(/(?:\\)*\?/g, function (val) {
        return val.charAt(0) === '\\' ? '?' : '\x01';
      });
      return str.replace(/(?:\\)*\*/g, function (val) {
        return val.charAt(0) === '\\' ? '*' : '\x02';
      });
    }
  }, {
    key: 'createWildcardsRegExp',
    value: function createWildcardsRegExp(str) {
      var spaces = this.opt.wildcards === 'withSpaces';
      return str.replace(/\u0001/g, spaces ? '[\\S\\s]?' : '\\S?').replace(/\u0002/g, spaces ? '[\\S\\s]*?' : '\\S*');
    }
  }, {
    key: 'setupIgnoreJoinersRegExp',
    value: function setupIgnoreJoinersRegExp(str) {
      return str.replace(/[^(|)\\]/g, function (val, indx, original) {
        var nextChar = original.charAt(indx + 1);
        if (/[(|)\\]/.test(nextChar) || nextChar === '') {
          return val;
        } else {
          return val + '\0';
        }
      });
    }
  }, {
    key: 'createJoinersRegExp',
    value: function createJoinersRegExp(str) {
      var joiner = [];
      var ignorePunctuation = this.opt.ignorePunctuation;
      if (Array.isArray(ignorePunctuation) && ignorePunctuation.length) {
        joiner.push(this.escapeStr(ignorePunctuation.join('')));
      }
      if (this.opt.ignoreJoiners) {
        joiner.push('\\u00ad\\u200b\\u200c\\u200d');
      }
      return joiner.length ? str.split(/\u0000+/).join('[' + joiner.join('') + ']*') : str;
    }
  }, {
    key: 'createDiacriticsRegExp',
    value: function createDiacriticsRegExp(str) {
      var sens = this.opt.caseSensitive ? '' : 'i',
          dct = this.opt.caseSensitive ? ['aàáảãạăằắẳẵặâầấẩẫậäåāą', 'AÀÁẢÃẠĂẰẮẲẴẶÂẦẤẨẪẬÄÅĀĄ', 'cçćč', 'CÇĆČ', 'dđď', 'DĐĎ', 'eèéẻẽẹêềếểễệëěēę', 'EÈÉẺẼẸÊỀẾỂỄỆËĚĒĘ', 'iìíỉĩịîïī', 'IÌÍỈĨỊÎÏĪ', 'lł', 'LŁ', 'nñňń', 'NÑŇŃ', 'oòóỏõọôồốổỗộơởỡớờợöøō', 'OÒÓỎÕỌÔỒỐỔỖỘƠỞỠỚỜỢÖØŌ', 'rř', 'RŘ', 'sšśșş', 'SŠŚȘŞ', 'tťțţ', 'TŤȚŢ', 'uùúủũụưừứửữựûüůū', 'UÙÚỦŨỤƯỪỨỬỮỰÛÜŮŪ', 'yýỳỷỹỵÿ', 'YÝỲỶỸỴŸ', 'zžżź', 'ZŽŻŹ'] : ['aàáảãạăằắẳẵặâầấẩẫậäåāąAÀÁẢÃẠĂẰẮẲẴẶÂẦẤẨẪẬÄÅĀĄ', 'cçćčCÇĆČ', 'dđďDĐĎ', 'eèéẻẽẹêềếểễệëěēęEÈÉẺẼẸÊỀẾỂỄỆËĚĒĘ', 'iìíỉĩịîïīIÌÍỈĨỊÎÏĪ', 'lłLŁ', 'nñňńNÑŇŃ', 'oòóỏõọôồốổỗộơởỡớờợöøōOÒÓỎÕỌÔỒỐỔỖỘƠỞỠỚỜỢÖØŌ', 'rřRŘ', 'sšśșşSŠŚȘŞ', 'tťțţTŤȚŢ', 'uùúủũụưừứửữựûüůūUÙÚỦŨỤƯỪỨỬỮỰÛÜŮŪ', 'yýỳỷỹỵÿYÝỲỶỸỴŸ', 'zžżźZŽŻŹ'];
      var handled = [];
      str.split('').forEach(function (ch) {
        dct.every(function (dct) {
          if (dct.indexOf(ch) !== -1) {
            if (handled.indexOf(dct) > -1) {
              return false;
            }
            str = str.replace(new RegExp('[' + dct + ']', 'gm' + sens), '[' + dct + ']');
            handled.push(dct);
          }
          return true;
        });
      });
      return str;
    }
  }, {
    key: 'createMergedBlanksRegExp',
    value: function createMergedBlanksRegExp(str) {
      return str.replace(/[\s]+/gmi, '[\\s]+');
    }
  }, {
    key: 'createAccuracyRegExp',
    value: function createAccuracyRegExp(str) {
      var _this = this;

      var chars = '!"#$%&\'()*+,-./:;<=>?@[\\]^_`{|}~¡¿';
      var acc = this.opt.accuracy,
          val = typeof acc === 'string' ? acc : acc.value,
          ls = typeof acc === 'string' ? [] : acc.limiters,
          lsJoin = '';
      ls.forEach(function (limiter) {
        lsJoin += '|' + _this.escapeStr(limiter);
      });
      switch (val) {
        case 'partially':
        default:
          return '()(' + str + ')';
        case 'complementary':
          lsJoin = '\\s' + (lsJoin ? lsJoin : this.escapeStr(chars));
          return '()([^' + lsJoin + ']*' + str + '[^' + lsJoin + ']*)';
        case 'exactly':
          return '(^|\\s' + lsJoin + ')(' + str + ')(?=$|\\s' + lsJoin + ')';
      }
    }
  }, {
    key: 'getSeparatedKeywords',
    value: function getSeparatedKeywords(sv) {
      var _this2 = this;

      var stack = [];
      sv.forEach(function (kw) {
        if (!_this2.opt.separateWordSearch) {
          if (kw.trim() && stack.indexOf(kw) === -1) {
            stack.push(kw);
          }
        } else {
          kw.split(' ').forEach(function (kwSplitted) {
            if (kwSplitted.trim() && stack.indexOf(kwSplitted) === -1) {
              stack.push(kwSplitted);
            }
          });
        }
      });
      return {
        'keywords': stack.sort(function (a, b) {
          return b.length - a.length;
        }),
        'length': stack.length
      };
    }
  }, {
    key: 'isNumeric',
    value: function isNumeric(value) {
      return Number(parseFloat(value)) == value;
    }
  }, {
    key: 'checkRanges',
    value: function checkRanges(array) {
      var _this3 = this;

      if (!Array.isArray(array) || Object.prototype.toString.call(array[0]) !== '[object Object]') {
        this.log('markRanges() will only accept an array of objects');
        this.opt.noMatch(array);
        return [];
      }
      var stack = [];
      var last = 0;
      array.sort(function (a, b) {
        return a.start - b.start;
      }).forEach(function (item) {
        var _callNoMatchOnInvalid = _this3.callNoMatchOnInvalidRanges(item, last),
            start = _callNoMatchOnInvalid.start,
            end = _callNoMatchOnInvalid.end,
            valid = _callNoMatchOnInvalid.valid;

        if (valid) {
          item.start = start;
          item.length = end - start;
          stack.push(item);
          last = end;
        }
      });
      return stack;
    }
  }, {
    key: 'callNoMatchOnInvalidRanges',
    value: function callNoMatchOnInvalidRanges(range, last) {
      var start = void 0,
          end = void 0,
          valid = false;
      if (range && typeof range.start !== 'undefined') {
        start = parseInt(range.start, 10);
        end = start + parseInt(range.length, 10);
        if (this.isNumeric(range.start) && this.isNumeric(range.length) && end - last > 0 && end - start > 0) {
          valid = true;
        } else {
          this.log('Ignoring invalid or overlapping range: ' + ('' + JSON.stringify(range)));
          this.opt.noMatch(range);
        }
      } else {
        this.log('Ignoring invalid range: ' + JSON.stringify(range));
        this.opt.noMatch(range);
      }
      return {
        start: start,
        end: end,
        valid: valid
      };
    }
  }, {
    key: 'checkWhitespaceRanges',
    value: function checkWhitespaceRanges(range, originalLength, string) {
      var end = void 0,
          valid = true,
          max = string.length,
          offset = originalLength - max,
          start = parseInt(range.start, 10) - offset;
      start = start > max ? max : start;
      end = start + parseInt(range.length, 10);
      if (end > max) {
        end = max;
        this.log('End range automatically set to the max value of ' + max);
      }
      if (start < 0 || end - start < 0 || start > max || end > max) {
        valid = false;
        this.log('Invalid range: ' + JSON.stringify(range));
        this.opt.noMatch(range);
      } else if (string.substring(start, end).replace(/\s+/g, '') === '') {
        valid = false;
        this.log('Skipping whitespace only range: ' + JSON.stringify(range));
        this.opt.noMatch(range);
      }
      return {
        start: start,
        end: end,
        valid: valid
      };
    }
  }, {
    key: 'getTextNodes',
    value: function getTextNodes(cb) {
      var _this4 = this;

      var val = '',
          nodes = [];
      this.iterator.forEachNode(NodeFilter.SHOW_TEXT, function (node) {
        nodes.push({
          start: val.length,
          end: (val += node.textContent).length,
          node: node
        });
      }, function (node) {
        if (_this4.matchesExclude(node.parentNode)) {
          return NodeFilter.FILTER_REJECT;
        } else {
          return NodeFilter.FILTER_ACCEPT;
        }
      }, function () {
        cb({
          value: val,
          nodes: nodes
        });
      });
    }
  }, {
    key: 'matchesExclude',
    value: function matchesExclude(el) {
      return DOMIterator.matches(el, this.opt.exclude.concat(['script', 'style', 'title', 'head', 'html']));
    }
  }, {
    key: 'wrapRangeInTextNode',
    value: function wrapRangeInTextNode(node, start, end) {
      var hEl = !this.opt.element ? 'mark' : this.opt.element,
          startNode = node.splitText(start),
          ret = startNode.splitText(end - start);
      var repl = document.createElement(hEl);
      repl.setAttribute('data-markjs', 'true');
      if (this.opt.className) {
        repl.setAttribute('class', this.opt.className);
      }
      repl.textContent = startNode.textContent;
      startNode.parentNode.replaceChild(repl, startNode);
      return ret;
    }
  }, {
    key: 'wrapRangeInMappedTextNode',
    value: function wrapRangeInMappedTextNode(dict, start, end, filterCb, eachCb) {
      var _this5 = this;

      dict.nodes.every(function (n, i) {
        var sibl = dict.nodes[i + 1];
        if (typeof sibl === 'undefined' || sibl.start > start) {
          if (!filterCb(n.node)) {
            return false;
          }
          var s = start - n.start,
              e = (end > n.end ? n.end : end) - n.start,
              startStr = dict.value.substr(0, n.start),
              endStr = dict.value.substr(e + n.start);
          n.node = _this5.wrapRangeInTextNode(n.node, s, e);
          dict.value = startStr + endStr;
          dict.nodes.forEach(function (k, j) {
            if (j >= i) {
              if (dict.nodes[j].start > 0 && j !== i) {
                dict.nodes[j].start -= e;
              }
              dict.nodes[j].end -= e;
            }
          });
          end -= e;
          eachCb(n.node.previousSibling, n.start);
          if (end > n.end) {
            start = n.end;
          } else {
            return false;
          }
        }
        return true;
      });
    }
  }, {
    key: 'wrapMatches',
    value: function wrapMatches(regex, ignoreGroups, filterCb, eachCb, endCb) {
      var _this6 = this;

      var matchIdx = ignoreGroups === 0 ? 0 : ignoreGroups + 1;
      this.getTextNodes(function (dict) {
        dict.nodes.forEach(function (node) {
          node = node.node;
          var match = void 0;
          while ((match = regex.exec(node.textContent)) !== null && match[matchIdx] !== '') {
            if (!filterCb(match[matchIdx], node)) {
              continue;
            }
            var pos = match.index;
            if (matchIdx !== 0) {
              for (var i = 1; i < matchIdx; i++) {
                pos += match[i].length;
              }
            }
            node = _this6.wrapRangeInTextNode(node, pos, pos + match[matchIdx].length);
            eachCb(node.previousSibling);
            regex.lastIndex = 0;
          }
        });
        endCb();
      });
    }
  }, {
    key: 'wrapMatchesAcrossElements',
    value: function wrapMatchesAcrossElements(regex, ignoreGroups, filterCb, eachCb, endCb) {
      var _this7 = this;

      var matchIdx = ignoreGroups === 0 ? 0 : ignoreGroups + 1;
      this.getTextNodes(function (dict) {
        var match = void 0;
        while ((match = regex.exec(dict.value)) !== null && match[matchIdx] !== '') {
          var start = match.index;
          if (matchIdx !== 0) {
            for (var i = 1; i < matchIdx; i++) {
              start += match[i].length;
            }
          }
          var end = start + match[matchIdx].length;
          _this7.wrapRangeInMappedTextNode(dict, start, end, function (node) {
            return filterCb(match[matchIdx], node);
          }, function (node, lastIndex) {
            regex.lastIndex = lastIndex;
            eachCb(node);
          });
        }
        endCb();
      });
    }
  }, {
    key: 'wrapRangeFromIndex',
    value: function wrapRangeFromIndex(ranges, filterCb, eachCb, endCb) {
      var _this8 = this;

      this.getTextNodes(function (dict) {
        var originalLength = dict.value.length;
        ranges.forEach(function (range, counter) {
          var _checkWhitespaceRange = _this8.checkWhitespaceRanges(range, originalLength, dict.value),
              start = _checkWhitespaceRange.start,
              end = _checkWhitespaceRange.end,
              valid = _checkWhitespaceRange.valid;

          if (valid) {
            _this8.wrapRangeInMappedTextNode(dict, start, end, function (node) {
              return filterCb(node, range, dict.value.substring(start, end), counter);
            }, function (node) {
              eachCb(node, range);
            });
          }
        });
        endCb();
      });
    }
  }, {
    key: 'unwrapMatches',
    value: function unwrapMatches(node) {
      var parent = node.parentNode;
      var docFrag = document.createDocumentFragment();
      while (node.firstChild) {
        docFrag.appendChild(node.removeChild(node.firstChild));
      }
      parent.replaceChild(docFrag, node);
      if (!this.ie) {
        parent.normalize();
      } else {
        this.normalizeTextNode(parent);
      }
    }
  }, {
    key: 'normalizeTextNode',
    value: function normalizeTextNode(node) {
      if (!node) {
        return;
      }
      if (node.nodeType === 3) {
        while (node.nextSibling && node.nextSibling.nodeType === 3) {
          node.nodeValue += node.nextSibling.nodeValue;
          node.parentNode.removeChild(node.nextSibling);
        }
      } else {
        this.normalizeTextNode(node.firstChild);
      }
      this.normalizeTextNode(node.nextSibling);
    }
  }, {
    key: 'markRegExp',
    value: function markRegExp(regexp, opt) {
      var _this9 = this;

      this.opt = opt;
      this.log('Searching with expression "' + regexp + '"');
      var totalMatches = 0,
          fn = 'wrapMatches';
      var eachCb = function eachCb(element) {
        totalMatches++;
        _this9.opt.each(element);
      };
      if (this.opt.acrossElements) {
        fn = 'wrapMatchesAcrossElements';
      }
      this[fn](regexp, this.opt.ignoreGroups, function (match, node) {
        return _this9.opt.filter(node, match, totalMatches);
      }, eachCb, function () {
        if (totalMatches === 0) {
          _this9.opt.noMatch(regexp);
        }
        _this9.opt.done(totalMatches);
      });
    }
  }, {
    key: 'mark',
    value: function mark(sv, opt) {
      var _this10 = this;

      this.opt = opt;
      var totalMatches = 0,
          fn = 'wrapMatches';

      var _getSeparatedKeywords = this.getSeparatedKeywords(typeof sv === 'string' ? [sv] : sv),
          kwArr = _getSeparatedKeywords.keywords,
          kwArrLen = _getSeparatedKeywords.length,
          sens = this.opt.caseSensitive ? '' : 'i',
          handler = function handler(kw) {
        var regex = new RegExp(_this10.createRegExp(kw), 'gm' + sens),
            matches = 0;
        _this10.log('Searching with expression "' + regex + '"');
        _this10[fn](regex, 1, function (term, node) {
          return _this10.opt.filter(node, kw, totalMatches, matches);
        }, function (element) {
          matches++;
          totalMatches++;
          _this10.opt.each(element);
        }, function () {
          if (matches === 0) {
            _this10.opt.noMatch(kw);
          }
          if (kwArr[kwArrLen - 1] === kw) {
            _this10.opt.done(totalMatches);
          } else {
            handler(kwArr[kwArr.indexOf(kw) + 1]);
          }
        });
      };

      if (this.opt.acrossElements) {
        fn = 'wrapMatchesAcrossElements';
      }
      if (kwArrLen === 0) {
        this.opt.done(totalMatches);
      } else {
        handler(kwArr[0]);
      }
    }
  }, {
    key: 'markRanges',
    value: function markRanges(rawRanges, opt) {
      var _this11 = this;

      this.opt = opt;
      var totalMatches = 0,
          ranges = this.checkRanges(rawRanges);
      if (ranges && ranges.length) {
        this.log('Starting to mark with the following ranges: ' + JSON.stringify(ranges));
        this.wrapRangeFromIndex(ranges, function (node, range, match, counter) {
          return _this11.opt.filter(node, range, match, counter);
        }, function (element, range) {
          totalMatches++;
          _this11.opt.each(element, range);
        }, function () {
          _this11.opt.done(totalMatches);
        });
      } else {
        this.opt.done(totalMatches);
      }
    }
  }, {
    key: 'unmark',
    value: function unmark(opt) {
      var _this12 = this;

      this.opt = opt;
      var sel = this.opt.element ? this.opt.element : '*';
      sel += '[data-markjs]';
      if (this.opt.className) {
        sel += '.' + this.opt.className;
      }
      this.log('Removal selector "' + sel + '"');
      this.iterator.forEachNode(NodeFilter.SHOW_ELEMENT, function (node) {
        _this12.unwrapMatches(node);
      }, function (node) {
        var matchesSel = DOMIterator.matches(node, sel),
            matchesExclude = _this12.matchesExclude(node);
        if (!matchesSel || matchesExclude) {
          return NodeFilter.FILTER_REJECT;
        } else {
          return NodeFilter.FILTER_ACCEPT;
        }
      }, this.opt.done);
    }
  }, {
    key: 'opt',
    set: function set$$1(val) {
      this._opt = _extends({}, {
        'element': '',
        'className': '',
        'exclude': [],
        'iframes': false,
        'iframesTimeout': 5000,
        'separateWordSearch': true,
        'diacritics': true,
        'synonyms': {},
        'accuracy': 'partially',
        'acrossElements': false,
        'caseSensitive': false,
        'ignoreJoiners': false,
        'ignoreGroups': 0,
        'ignorePunctuation': [],
        'wildcards': 'disabled',
        'each': function each() {},
        'noMatch': function noMatch() {},
        'filter': function filter() {
          return true;
        },
        'done': function done() {},
        'debug': false,
        'log': window.console
      }, val);
    },
    get: function get$$1() {
      return this._opt;
    }
  }, {
    key: 'iterator',
    get: function get$$1() {
      return new DOMIterator(this.ctx, this.opt.iframes, this.opt.exclude, this.opt.iframesTimeout);
    }
  }]);
  return Mark;
}();

function Mark(ctx) {
  var _this = this;

  var instance = new Mark$1(ctx);
  this.mark = function (sv, opt) {
    instance.mark(sv, opt);
    return _this;
  };
  this.markRegExp = function (sv, opt) {
    instance.markRegExp(sv, opt);
    return _this;
  };
  this.markRanges = function (sv, opt) {
    instance.markRanges(sv, opt);
    return _this;
  };
  this.unmark = function (opt) {
    instance.unmark(opt);
    return _this;
  };
  return this;
}

return Mark;

})));


/***/ }),

/***/ "./src/js/components/help-search.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = helpSearch;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__faq_search_js__ = __webpack_require__("./src/js/faq-search.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__scroll_js__ = __webpack_require__("./src/js/components/scroll.js");



function helpSearch($container, _ref) {
  var $refs = _ref.$refs;

  var search = Object(__WEBPACK_IMPORTED_MODULE_0__faq_search_js__["default"])($container);

  var $form = $refs.form[0];
  var $input = $refs.input[0];

  function onSubmit(e) {
    e.preventDefault();
    Object(__WEBPACK_IMPORTED_MODULE_1__scroll_js__["scrollTo"])($refs.faqs[0], {
      scrollMode: 'always',
      offset: 100
    });
  }

  function onInput(e) {
    e.preventDefault();

    search.search($input.value.trim());
  }

  $form.addEventListener('submit', onSubmit);
  $input.addEventListener('input', onInput);

  return function () {
    $form.removeEventListener('submit', onSubmit);
    $input.removeEventListener('submit', onInput);
  };
}

/***/ }),

/***/ "./src/js/components/scroll.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = scroll;
/* harmony export (immutable) */ __webpack_exports__["scrollTo"] = scrollTo;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_compute_scroll_into_view__ = __webpack_require__("./node_modules/compute-scroll-into-view/es/index.js");


var FOCUSABLE_SELECTOR = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';

function matches($el, selector) {
  if ($el.matches) {
    return $el.matches(selector);
  } else if ($el.msMatchesSelector) {
    return $el.msMatchesSelector(selector);
  } else if ($el.webkitMatchesSelector) {
    return $el.webkitMatchesSelector(selector);
  }
}

function scroll($el) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$scrollMode = _ref.scrollMode,
      scrollMode = _ref$scrollMode === undefined ? 'if-needed' : _ref$scrollMode,
      _ref$block = _ref.block,
      block = _ref$block === undefined ? 'start' : _ref$block,
      _ref$inline = _ref.inline,
      inline = _ref$inline === undefined ? 'nearest' : _ref$inline,
      _ref$offset = _ref.offset,
      offset = _ref$offset === undefined ? 0 : _ref$offset,
      _ref$smooth = _ref.smooth,
      smooth = _ref$smooth === undefined ? 'true' : _ref$smooth,
      _ref$history = _ref.history,
      history = _ref$history === undefined ? 'none' : _ref$history;

  function onClick(e) {
    e.preventDefault();
    var href = $el.getAttribute('href');
    scrollTo(href, {
      scrollMode: scrollMode,
      block: block,
      inline: inline,
      offset: offset,
      smooth: smooth,
      history: history
    });
  }

  function onChange() {
    if ($el.value) {
      scrollTo('#' + $el.value, {
        scrollMode: scrollMode,
        block: block,
        inline: inline,
        offset: offset,
        smooth: smooth,
        history: history
      });
    }
  }

  if ($el.tagName === 'SELECT') {
    $el.addEventListener('change', onChange);
    return function () {
      return $el.removeEventListener('change', onChange);
    };
  }
  $el.addEventListener('click', onClick);
  return function () {
    return $el.removeEventListener('click', onClick);
  };
}

function scrollTo(href) {
  var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref2$scrollMode = _ref2.scrollMode,
      scrollMode = _ref2$scrollMode === undefined ? 'if-needed' : _ref2$scrollMode,
      _ref2$block = _ref2.block,
      block = _ref2$block === undefined ? 'start' : _ref2$block,
      _ref2$inline = _ref2.inline,
      inline = _ref2$inline === undefined ? 'nearest' : _ref2$inline,
      _ref2$offset = _ref2.offset,
      offset = _ref2$offset === undefined ? 0 : _ref2$offset,
      _ref2$smooth = _ref2.smooth,
      smooth = _ref2$smooth === undefined ? 'true' : _ref2$smooth,
      _ref2$history = _ref2.history,
      history = _ref2$history === undefined ? 'none' : _ref2$history;

  var $target = typeof href === 'string' ? document.querySelector(href) : href;

  if (!$target) {
    throw new Error('Couldn\u2019t find element for href ' + href);
  }

  var reduceMotion = 'matchMedia' in window && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var behavior = smooth === 'true' && !reduceMotion ? 'smooth' : 'auto';

  if (history !== 'none') {
    window.history[history + 'State']({}, '', href);
  }

  var actions = Object(__WEBPACK_IMPORTED_MODULE_0_compute_scroll_into_view__["a" /* default */])($target, {
    scrollMode: scrollMode,
    block: block,
    inline: inline
  });

  if (actions.length) {
    var $offset = document.querySelector('[data-scroll-offset]');
    if ($offset) offset += $offset.offsetHeight;
  }

  var $$focusable = matches($target, FOCUSABLE_SELECTOR) ? [$target] : $target.querySelectorAll(FOCUSABLE_SELECTOR);

  if ($$focusable.length) {
    actions.forEach(function (action) {
      action.originalTop = action.el.scrollTop;
      action.originalLeft = action.el.scrollLeft;
    });

    $$focusable[0].focus();

    actions.forEach(function (_ref3) {
      var $el = _ref3.el,
          originalTop = _ref3.originalTop;

      $el.scrollTop = originalTop;
    });
  }

  actions.forEach(function (_ref4) {
    var $el = _ref4.el,
        top = _ref4.top,
        left = _ref4.left;

    try {
      $el.scroll({
        top: top - offset,
        left: left,
        behavior: behavior
      });
    } catch (_) {
      $el.scrollTop = top - offset;
      $el.scrollLeft = left;
    }
  });
}

/***/ }),

/***/ "./src/js/faq-search.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = faqSearch;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_flexsearch_dist_flexsearch_light_js__ = __webpack_require__("./node_modules/flexsearch/dist/flexsearch.light.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_flexsearch_dist_flexsearch_light_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_flexsearch_dist_flexsearch_light_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mark_js__ = __webpack_require__("./node_modules/mark.js/dist/mark.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mark_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mark_js__);



function faqSearch($container) {
  var searchIndex = __WEBPACK_IMPORTED_MODULE_0_flexsearch_dist_flexsearch_light_js___default.a.create();[].slice.call($container.querySelectorAll('[data-faq-id]')).forEach(function ($faq) {
    searchIndex.add(parseInt($faq.getAttribute('data-faq-id'), 10), $faq.querySelector('h2').textContent.trim() + '\n' + $faq.querySelector('.accordion-content').textContent.trim());
  });

  var $$faqs = [].slice.call($container.querySelectorAll('[data-faq-id]'));

  var $noResults = document.createElement('p');
  $noResults.className = 'mt-30 sm:mt-40 text-center';

  var markers = $$faqs.map(function ($faq) {
    return new __WEBPACK_IMPORTED_MODULE_1_mark_js___default.a($faq);
  });

  function search(term) {
    if (term === '') {
      $$faqs.forEach(function ($faq, i) {
        $faq.hidden = false;

        markers[i].unmark();
      });

      $noResults.parentNode && $noResults.parentNode.removeChild($noResults);
      return;
    }

    var results = searchIndex.search(term);

    if (results.length === 0) {
      $noResults.innerHTML = 'No results for \u201C' + escapeHtml(term) + '\u201D';
      $container.querySelector('.accordion').insertBefore($noResults, $container.querySelector('.accordion').firstElementChild);
    } else {
      $noResults.parentNode && $noResults.parentNode.removeChild($noResults);
    }

    $$faqs.forEach(function ($faq, i) {
      var matches = results.indexOf(parseInt($faq.getAttribute('data-faq-id'), 10)) !== -1;
      if (matches) {
        markers[i].unmark();
        markers[i].mark(term, {
          className: 'bg-yellow'
        });
      }
      $faq.hidden = !matches;
    });
  }

  return {
    index: searchIndex,
    search: search
  };
}

function escapeHtml(html) {
  var text = document.createTextNode(html);
  var p = document.createElement('p');
  p.appendChild(text);
  return p.innerHTML;
}

/***/ })

});


// WEBPACK FOOTER //
// conditioner22.4ed4b8bad081be30b589.js